import * as React from "react";
import { Outlet } from "react-router-dom";

import { Header } from "./header";

function Layout() {
  return (
    <div className="flex flex-col min-h-screen bg-neutral-100">
      <Header />

      <main className="flex-1 overflow-hidden">
        <Outlet />
      </main>
    </div>
  );
}

export { Layout };
